import { ColumnLayout, Toggle } from 'AWS-UI-Components-React';
import React from 'react';
import { deepClone } from '../../utilities';
import { isAdmin } from '../../utils/access-utils';
import { getJSClient } from '../js_client';
import { displayFlag, displayStatusBadge } from './simulator_utils';

export class SimulationDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      simulation: this.props.simulation || {},
    };
  }

  componentDidMount = () => {
    this.client = getJSClient();
  }

  updateSimulation = (event) => {
    let payload = {};
    let simulation = deepClone(this.props.simulation);
    simulation['publicView'] = event.detail.checked;
    payload['simulation'] = simulation;
    this.client.updateSimulation(() => {}, this.onUpdateSimulationFailure, payload);
  }

  onUpdateSimulationFailure = (error) => {
    console.log(error);
  };

  render() {
    const { simulation } = this.state;
    const { user, latestTimestamp, endMonth, name, id, timestamp, startMonth, arn,
      stagingArea, benchmarkAdjustmentStagingArea, publicView } = simulation;
    const { loadCpData, loadDucsiData, loadFortuneData, loadLiquidationData, loadSpotData } = simulation;
    const { loadCpDataMonths, loadDucsiDataMonths, loadFortuneDataMonths, loadLiquidationDataMonths, loadSpotDataMonths } = simulation;
    const { syncRawData, syncAurora, runAccuracyPipeline } = simulation;

    return (
      <div className="awsui-util-container">
        <div className="awsui-util-container-header">
          <h2>Details</h2>
        </div>
        <ColumnLayout columns={ 2 } variant="text-grid">
          <div data-awsui-column-layout-root="true">
            <div>
              <div className="awsui-util-spacing-v-s">
                <div>
                  <div className="awsui-util-label">Id</div>
                  <div>{ id }</div>
                </div>
                <div>
                  <div className="awsui-util-label">Name</div>
                  <div>{ name }</div>
                </div>

                <div>
                  <div className="awsui-util-label">User</div>
                  <div>{ user }</div>
                </div>
                <div>
                  <div className="awsui-util-label">Latest Status</div>
                  <div>{ displayStatusBadge(simulation) }</div>
                </div>
                <div className="awsui-util-spacing-v-s">
                  <div>
                    <div className="awsui-util-label">Start Time</div>
                    <div>{ new Date(timestamp).toLocaleString() }</div>
                  </div>
                  <div>
                    <div className="awsui-util-label">Last Updated</div>
                    {
                      arn && isAdmin(this.props.identity)
                      ? <a href={ `https://us-west-2.console.aws.amazon.com/states/home?region=us-west-2#/executions/details/${ arn }` } target="_blank">{ new Date(latestTimestamp).toLocaleString() }</a>
                      : new Date(latestTimestamp).toLocaleString()
                    }
                  </div>
                  { (user === this.props.user || isAdmin(this.props.identity)) &&
                  <div>
                    <Toggle onChange={this.updateSimulation} checked={publicView || false}>
                      Public
                    </Toggle>
                  </div>
                  }
                </div>
              </div>
            </div>
            <div>
              <div className="awsui-util-spacing-v-s">
                <div>
                  <div className="awsui-util-label">Simulation Data Range</div>
                  <ul>
                    <li>Start Month - { startMonth }</li>
                    <li>End Month - { endMonth }</li>
                  </ul>
                </div>
              </div>
              <div className="awsui-util-spacing-v-s">
                <div>
                  <div className="awsui-util-label">Data Re-Load Flags</div>
                  <ul>
                    <li>CP Data - { displayFlag(loadCpData, 'Yes - ' + loadCpDataMonths + ' Month(s)') }</li>
                    <li>DUCSI Data - { displayFlag(loadDucsiData, 'Yes - ' + loadDucsiDataMonths + ' Month(s)') }</li>
                    <li>Fortune Data - { displayFlag(loadFortuneData, 'Yes - ' + loadFortuneDataMonths + ' Month(s)') }</li>
                    <li>Liquidation Data - { displayFlag(loadLiquidationData, 'Yes - ' + loadLiquidationDataMonths + ' Month(s)') }</li>
                    <li>Spot Data - { displayFlag(loadSpotData, 'Yes - ' + loadSpotDataMonths + ' Month(s)') }</li>
                  </ul>
                </div>
              </div>

              <div className="awsui-util-spacing-v-s">
                <div>
                  <div className="awsui-util-label">Execute Flags</div>
                  <ul>
                    <li>Accuracy Pipeline - { displayFlag(runAccuracyPipeline) }</li>
                    <li>Aurora Sync - { displayFlag(syncAurora) }</li>
                    <li>Raw Data Sync - { displayFlag(syncRawData) }</li>
                  </ul>
                </div>
              </div>

              <div className="awsui-util-spacing-v-s">
                <div>
                  <div className="awsui-util-label">Other Configuration</div>
                  <ul>
                    <li>Staged Changes - { displayFlag(stagingArea, stagingArea) }</li>
                    <li>Benchmark Adjustment Draft - { displayFlag(benchmarkAdjustmentStagingArea, benchmarkAdjustmentStagingArea) }</li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </ColumnLayout>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/simulator/simulation_details.jsx